import { MaskedInput } from '@/behaviour/masked_input/index'
import { Select2 } from '@/behaviour/select2/index'
import { Cookies } from '@/libs/cookies/index'
import { $ } from '@/libs/jquery/index'
import { UTMFields } from '@/libs/utm_fields/index'
import { ILeadsResponse } from '@/typings/leads_response'
import { Messages } from '@/utilities/messages'
import { PopUps } from '@/utilities/popups'

export const leadsRemoteFormSelector = '[data-selector="leadsRemoteForm"]'

export class LeadsForm {
  /* Класс для управления формами продуктов
   * @param {string} domContainer - селектор для контейнера формы
   * @param {string} urlToGet - урл для получения содержимого формы
  */
  private wrapper: JQuery = null
  private form: string

  private readonly selectors: ISelectors = {
    form: '',
    wrapper: '',
  }

  constructor(domContainer: string, urlToGet: string, formSelector: string = `${leadsRemoteFormSelector} form`) {
    this.selectors.wrapper = domContainer
    this.selectors.form = formSelector
    this.wrapper = $(this.selectors.wrapper)

    $
      .get({url: urlToGet})
      .done((data: string) => {
        this.addFormToPage(data)
      })
  }

  private addFormToPage(content: string): void {
    UTMFields.wait().then(() => {
      this.wrapper.html(content)
      UTMFields.fill()

      this.addCustomStyles()
      this.initValidations()
      this.addMasks()
      this.initListeners()
      this.triggerFormRendered()
    })
  }

  private addCustomStyles(): void {
    Select2.reinit()
  }

  private initValidations(): void {
    if (['health_manage', 'insurance_funds'].indexOf($(this.selectors.form).data('product')) === -1) {
      $(this.selectors.form).validate({
        errorPlacement: (error, element) => {
          if (element.data('errorPlacement')) {
            const errorContainerSelector = element.data('errorPlacement')
            $(errorContainerSelector).append(error)
          } else {
            error.insertAfter(element)
          }
        },
      })
    }
  }

  private addMasks(): void {
    MaskedInput.reinit()
  }

  private triggerFormRendered(): void {
    $(document).trigger('form:lead:rendered')
  }

  private initListeners(): void {
    $('body')
      .on('ajax:success', this.selectors.form, (xhr, data, status) => {
        this.wrapper.find('input[type="submit"]').removeAttr('disabled')
        UTMFields.clear()
        if ($(this.selectors.form).data('response') === 'own') {
          return true
        }
        if (data.url) {
          window.location = data.url

          return true
        }
      })
      .on('ajax:beforeSend', this.selectors.form, (event, xhr, status) => {
        $(document).trigger('submit_lead', $(this.selectors.form).attr('action'))
        this.wrapper.find('input[type="submit"]').attr('disabled', 'disabled')
      })
      .on('ajax:error', this.selectors.form, (data, status, xhr) => {
        this.wrapper
          .find('input[type="submit"]').removeAttr('disabled').end()
          .find('.js-form-error').show()
      })
      .on('click', `${this.selectors.form} input`, (e) => {
        this.wrapper.find('.js-form-error').hide()
      })
  }

  private showSuccessMessage(data: ILeadsResponse): void {
    const orderNumber: string = data.number
    PopUps.showPopupByContent({
      autoClose: 5000,
      closeCallback: () => window.location.reload(true),
      openCallback: () => {
        $(this.selectors.form).hide()
      },
      textContent: Messages.requestLeadSuccess(orderNumber),
    })
  }
}
